import { DOCUMENT, NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewEncapsulation,
    inject,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'fuse-fullscreen',
    templateUrl: './fullscreen.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'fuseFullscreen',
    imports: [
        MatButtonModule,
        MatTooltipModule,
        NgTemplateOutlet,
        MatIconModule,
    ],
})
export class FuseFullscreenComponent implements OnInit, OnDestroy {
    private _document = inject(DOCUMENT);
    private _cdr = inject(ChangeDetectorRef);

    @Input() iconTpl: TemplateRef<any>;
    @Input() tooltip: string;

    isFullscreen = false;
    private _boundHandler = () => this._onFullscreenChange();

    ngOnInit(): void {
        this._document.addEventListener('fullscreenchange', this._boundHandler);
    }

    ngOnDestroy(): void {
        this._document.removeEventListener('fullscreenchange', this._boundHandler);
    }

    private _onFullscreenChange(): void {
        this.isFullscreen = !!this._document.fullscreenElement;
        this._cdr.markForCheck();
    }

    /**
     * Toggle the fullscreen mode
     */
    toggleFullscreen(): void {
        if (!this._document.fullscreenEnabled) {
            console.log('Fullscreen is not available in this browser.');
            return;
        }

        // Check if the fullscreen is already open
        const fullScreen = this._document.fullscreenElement;

        // Toggle the fullscreen
        if (fullScreen) {
            this._document.exitFullscreen();
        } else {
            this._document.documentElement.requestFullscreen().catch(() => {
                console.error('Entering fullscreen mode failed.');
            });
        }
    }
}
